export default __webpack_public_path__ + "static/media/baseline-menu-24px.c0c361a0.svg";